/* ============================================================
   HEUREUX SHOPIFY THEME — theme.js
   All JS: Preloader, Cursor, Navbar, Particles, Tabs,
           Stats Counter, Quote Modal, Form Validation
   ============================================================ */

(function () {
  'use strict';

  /* ── PRELOADER ───────────────────────────────────────────── */
  var preloader = document.getElementById('preloader');
  var preloaderBar = document.getElementById('preloaderBar');
  var preloaderPct = document.getElementById('preloaderPct');
  var appWrapper = document.getElementById('appWrapper');

  var progress = 0;
  var preloaderInterval = setInterval(function () {
    progress += Math.random() * 18;
    if (progress >= 100) {
      progress = 100;
      clearInterval(preloaderInterval);
      setTimeout(function () {
        if (preloader) {
          preloader.style.opacity = '0';
          preloader.style.transition = 'opacity 0.5s ease';
          setTimeout(function () {
            preloader.style.display = 'none';
          }, 500);
        }
        if (appWrapper) {
          appWrapper.style.opacity = '1';
          appWrapper.style.transition = 'opacity 0.5s ease';
        }
      }, 300);
    }
    var pct = Math.min(Math.round(progress), 100);
    if (preloaderBar) preloaderBar.style.width = pct + '%';
    if (preloaderPct) preloaderPct.textContent = pct + '%';
  }, 120);

  /* ── CUSTOM CURSOR ───────────────────────────────────────── */
  var cursorDot = document.getElementById('cursorDot');
  var cursorRing = document.getElementById('cursorRing');

  if (cursorDot && cursorRing && window.innerWidth > 920) {
    document.addEventListener('mousemove', function (e) {
      cursorDot.style.left = e.clientX + 'px';
      cursorDot.style.top = e.clientY + 'px';
      cursorRing.style.left = e.clientX + 'px';
      cursorRing.style.top = e.clientY + 'px';
    });

    document.querySelectorAll('a, button, [data-hover]').forEach(function (el) {
      el.addEventListener('mouseenter', function () { cursorRing.classList.add('hovered'); });
      el.addEventListener('mouseleave', function () { cursorRing.classList.remove('hovered'); });
    });
  }

  /* ── NAVBAR SCROLL ───────────────────────────────────────── */
  var navbar = document.getElementById('navbar');
  if (navbar) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 60) {
        navbar.classList.add('navbar-scrolled');
      } else {
        navbar.classList.remove('navbar-scrolled');
      }
    }, { passive: true });
  }

  /* ── HAMBURGER MOBILE MENU ───────────────────────────────── */
  var hamburger = document.getElementById('hamburger');
  var mobileMenu = document.getElementById('mobileMenu');
  var menuOpen = false;

  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', function () {
      menuOpen = !menuOpen;
      mobileMenu.classList.toggle('mobile-menu-open', menuOpen);
      hamburger.innerHTML = menuOpen
        ? '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>'
        : '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>';
    });
  }

  /* ── SMOOTH SCROLL NAV LINKS ─────────────────────────────── */
  document.querySelectorAll('a[href^="#"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var href = this.getAttribute('href');
      if (href && href.length > 1) {
        var target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth' });
          if (mobileMenu) mobileMenu.classList.remove('mobile-menu-open');
          menuOpen = false;
        }
      }
    });
  });

  /* ── HERO PARTICLE CANVAS ─────────────────────────────────── */
  var canvas = document.getElementById('heroCanvas');
  if (canvas) {
    var ctx = canvas.getContext('2d');
    var particles = [];

    function resizeCanvas() {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    }
    resizeCanvas();
    window.addEventListener('resize', resizeCanvas, { passive: true });

    for (var i = 0; i < 70; i++) {
      particles.push({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        r: Math.random() * 1.4 + 0.4,
        vx: (Math.random() - 0.5) * 0.28,
        vy: (Math.random() - 0.5) * 0.28,
        alpha: Math.random() * 0.5 + 0.1
      });
    }

    function drawParticles() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      particles.forEach(function (p) {
        p.x += p.vx;
        p.y += p.vy;
        if (p.x < 0) p.x = canvas.width;
        if (p.x > canvas.width) p.x = 0;
        if (p.y < 0) p.y = canvas.height;
        if (p.y > canvas.height) p.y = 0;
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(33,199,255,' + p.alpha + ')';
        ctx.fill();
      });

      for (var a = 0; a < particles.length; a++) {
        for (var b = a + 1; b < particles.length; b++) {
          var dx = particles[a].x - particles[b].x;
          var dy = particles[a].y - particles[b].y;
          var dist = Math.sqrt(dx * dx + dy * dy);
          if (dist < 110) {
            ctx.beginPath();
            ctx.moveTo(particles[a].x, particles[a].y);
            ctx.lineTo(particles[b].x, particles[b].y);
            ctx.strokeStyle = 'rgba(33,199,255,' + (0.055 * (1 - dist / 110)) + ')';
            ctx.lineWidth = 0.5;
            ctx.stroke();
          }
        }
      }
      requestAnimationFrame(drawParticles);
    }
    drawParticles();
  }

  /* ── STATS COUNTER ANIMATION ─────────────────────────────── */
  function animateCounter(el, target) {
    var start = 0;
    var duration = 1800;
    var startTime = null;

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var elapsed = timestamp - startTime;
      var progress = Math.min(elapsed / duration, 1);
      var ease = 1 - Math.pow(1 - progress, 3);
      el.textContent = Math.round(ease * target).toLocaleString();
      if (progress < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  var statNumbers = document.querySelectorAll('.stat-number[data-target]');
  if (statNumbers.length && 'IntersectionObserver' in window) {
    var statsObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          var target = parseInt(el.getAttribute('data-target'), 10);
          animateCounter(el, target);
          statsObserver.unobserve(el);
        }
      });
    }, { threshold: 0.4 });

    statNumbers.forEach(function (el) { statsObserver.observe(el); });
  }

  /* ── PRODUCT TABS ─────────────────────────────────────────── */
var prodTabs = document.querySelectorAll('.prod-tab');

  var tabPanels = document.querySelectorAll('.tab-content-panel');

  var defaultProdTab = 'led-screens';

 

  function activateProdTab(tabName) {

    prodTabs.forEach(function (t) {

      if (t.getAttribute('data-tab') === tabName) {

        t.classList.add('prod-tab-active');

      } else {

        t.classList.remove('prod-tab-active');

      }

    });

 

    tabPanels.forEach(function (panel) {

      if (panel.getAttribute('data-panel') === tabName) {

        panel.style.display = 'block';

        panel.style.animation = 'fadeUp 0.4s ease';

      } else {

        panel.style.display = 'none';

      }

    });

  }

 

  prodTabs.forEach(function (tab) {

    tab.addEventListener('click', function () {

      activateProdTab(this.getAttribute('data-tab'));

    });

  });

 

  if (prodTabs.length) {

    activateProdTab(defaultProdTab);

  }

  /* ── QUOTE MODAL ─────────────────────────────────────────── */
  window.openQuoteModal = function () {
    var modal = document.getElementById('quoteModal');
    if (modal) {
      modal.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    }
  };

  window.closeQuoteModal = function () {
    var modal = document.getElementById('quoteModal');
    if (modal) {
      modal.style.display = 'none';
      document.body.style.overflow = '';
    }
  };

  // Wire all quote buttons
  var quoteButtons = [
    document.getElementById('navQuoteBtn'),
    document.getElementById('mobileQuoteBtn'),
    document.getElementById('heroQuoteBtn'),
    document.getElementById('footerQuoteBtn')
  ];
  quoteButtons.forEach(function (btn) {
    if (btn) btn.addEventListener('click', window.openQuoteModal);
  });

  // Close on Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') window.closeQuoteModal();
  });

  /* ── QUOTE FORM VALIDATION & SUBMIT ──────────────────────── */
  window.submitQuoteForm = function (e) {
    e.preventDefault();

    var name = document.getElementById('q-name');
    var mobile = document.getElementById('q-mobile');
    var email = document.getElementById('q-email');
    var product = document.getElementById('q-product');

    var errors = {};
    if (!name || !name.value.trim()) errors.name = 'Name is required';
    if (!mobile || !/^[6-9]\d{9}$/.test(mobile.value.trim())) errors.mobile = 'Enter a valid 10-digit mobile number';
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim())) errors.email = 'Enter a valid email address';
    if (!product || !product.value) errors.product = 'Please select a product';

    // Clear previous errors
    ['name', 'mobile', 'email', 'product'].forEach(function (field) {
      var grp = document.getElementById('grp-' + field);
      var err = document.getElementById('err-' + field);
      if (grp) grp.classList.remove('has-error');
      if (err) err.textContent = '';
    });

    // Show errors
    var hasErrors = false;
    Object.keys(errors).forEach(function (field) {
      hasErrors = true;
      var grp = document.getElementById('grp-' + field);
      var err = document.getElementById('err-' + field);
      if (grp) grp.classList.add('has-error');
      if (err) err.textContent = errors[field];
    });

    if (hasErrors) return;

    // Show loading
    var submitBtn = document.getElementById('quoteSubmitBtn');
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.innerHTML = '<span class="spinner"></span> Sending...';
    }

    // Submit to Shopify contact form endpoint
    var formData = new FormData();
    formData.append('form_type', 'contact');
    formData.append('utf8', '✓');
    formData.append('contact[name]', name ? name.value.trim() : '');
    formData.append('contact[email]', email ? email.value.trim() : '');
    formData.append('contact[phone]', mobile ? mobile.value.trim() : '');
    formData.append('contact[body]',
      'Product: ' + (product ? product.value : '') + '\n' +
      'Mobile: ' + (mobile ? mobile.value.trim() : '') + '\n' +
      'Company: ' + (document.getElementById('q-company') ? document.getElementById('q-company').value : '') + '\n' +
      'Message: ' + (document.getElementById('q-message') ? document.getElementById('q-message').value : '')
    );

    fetch('/contact', {
      method: 'POST',
      body: formData,
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
    .then(function () {
      showQuoteSuccess(name.value.trim(), product ? product.value : '');
    })
    .catch(function () {
      // Still show success - form data captured
      showQuoteSuccess(name ? name.value.trim() : '', product ? product.value : '');
    });
  };

  function showQuoteSuccess(name, productName) {
    var form = document.getElementById('quoteForm');
    var success = document.getElementById('quoteSuccess');
    var msg = document.getElementById('successMsg');
    if (form) form.style.display = 'none';
    if (success) success.style.display = 'flex';
    if (msg) msg.innerHTML = 'Thank you, <strong>' + name + '</strong>! We\'ve received your request for <strong>' + productName + '</strong>. Our team will contact you within 24 hours.';
  }

  /* ── SCROLL REVEAL ANIMATION ─────────────────────────────── */
  if ('IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    var revealEls = document.querySelectorAll(
      '.stat-card, .about-card, .prod-card, .why-card, .usecase-card, .cert-card, .trust-card, .it-service-card'
    );
    revealEls.forEach(function (el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(28px)';
      el.style.transition = 'opacity 0.55s ease, transform 0.55s ease';
      revealObserver.observe(el);
    });
  }

  /* ── ABOUT CARD SHINE EFFECT ─────────────────────────────── */
  document.querySelectorAll('.about-card').forEach(function (card) {
    card.addEventListener('mousemove', function (e) {
      var rect = card.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width) * 100;
      var y = ((e.clientY - rect.top) / rect.height) * 100;
      card.style.setProperty('--touch-x', x + '%');
      card.style.setProperty('--touch-y', y + '%');
    });
  });

  /* ── ACTIVE NAV LINK ON SCROLL ───────────────────────────── */
  var sections = document.querySelectorAll('section[id]');
  var navLinks = document.querySelectorAll('.nav-link');

  window.addEventListener('scroll', function () {
    var scrollY = window.scrollY + 120;
    sections.forEach(function (section) {
      var top = section.offsetTop;
      var height = section.offsetHeight;
      var id = section.getAttribute('id');
      if (scrollY >= top && scrollY < top + height) {
        navLinks.forEach(function (link) {
          link.classList.remove('active');
          if (link.getAttribute('href') === '#' + id) {
            link.classList.add('active');
          }
        });
      }
    });
  }, { passive: true });

})();
